<template>
  <AppInputField
    :id="id"
    :name="name"
    :label="label"
    :left-icon="leftIcon"
    :placeholder="placeholder"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :is-loading="isLoading"
    :required="required"
    :pattern="pattern"
    :error-message="errorMessage"
    @input="onInput"
    @change="onChange"
  />
</template>

<script>
import set from 'lodash/set';
import merge from 'lodash/merge';
import upperFirst from 'lodash/upperFirst';

import AppInputField from './AppInputField.vue';

export default {
  name: 'AppInputName',
  components: { AppInputField },
  props: {
    id: {
      type: [String, Number],
      default: 'name',
    },
    name: {
      type: [String, Number],
      default: 'name',
    },
    value: {
      type: [String, Number],
      default: 'name',
    },
    label: {
      type: [String, Number],
      default: 'Nombre',
    },
    placeholder: {
      type: [String, Number],
      default: 'Fulanito De Tal',
    },
    leftIcon: {
      type: String,
      default: 'person',
    },
    rightIcon: {
      type: String,
      default: '',
    },
    pattern: {
      type: String,
      default: '.{5,80}',
    },
    errorMessage: {
      type: String,
      default: 'Mínimo 5 carácteres, máximo 80.',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
  },
  methods: {
    toUpperFirst(event) {
      const { value: plainValue } = event.target;
      const value = plainValue.split(' ').reduce((acumm, letter) => {
        const isNumber = parseInt(letter, 10);

        if (Number.isNaN(isNumber)) {
          acumm.push(upperFirst(letter));
        }

        return acumm;
      }, []).join(' ');
      const newEvent = merge({}, event);

      set(newEvent, 'target.value', value);

      return newEvent;
    },
    onInput(event) {
      this.$emit('input', this.toUpperFirst(event));
    },
    onChange(event) {
      this.$emit('change', this.toUpperFirst(event));
    },
  },
};
</script>
